const getBinIconDataUrl = (color = "#8850EF") => {
  const svgString = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" viewBox="0 0 24 25">
        <rect width="24" height="24" y="0.43" fill="#fff" rx="4"></rect>
        <path stroke="${color}" strokeLinecap="round" strokeLinejoin="round"
          d="M7 9.097h9.333m-6 2v5.333M13 11.097v5.333m-2.667-10H13a.667.667 0 01.667.667v2h-4v-2a.667.667 0 01.666-.667zM7.667 9.097h8v8.667a.667.667 0 01-.667.666H8.333a.667.667 0 01-.666-.666V9.097z">
        </path>
      </svg>
    `;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgString)}`;
};
export default getBinIconDataUrl;
